module.exports = __webpack_public_path__ + "static/media/neutralpin.13d7fbbe.svg";